import React from "react";
import { components } from "react-select";

const DropDownMultiValueRemove = ({ children, ...props }) => {
    return <components.MultiValueRemove {...props}>{children}</components.MultiValueRemove>;
};

export default DropDownMultiValueRemove;
